module.exports = __webpack_public_path__ + "static/TOFU-e4547285e6363ca5d17f480bd1fdd25c.gif";